import type { FaireProductEntity } from "../../entity_types/product";

export const p_jbpmymy9u2: FaireProductEntity = {
  token: "p_jbpmymy9u2",
  type: "product",
  name: "Soul Eater, Vol. 4",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/51b08bbc622375a2e3616d20b59d183553ad6b8e9a6a530366198c606da02367.webp",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "At Maka's request, she and Soul meet with Doctor Stein for an intensive tutoring session. Although Stein warns that they may never be able to resonate again if they fail to complete the training, Maka insists, desperate to become stronger so that Soul is never hurt again. But Soul's strange nightmares have made him reluctant to seek power, and his unwillingness to share his fears only frustrates his partner. With their soul wavelengths pulling apart, will Maka and Soul be able to come together when danger emerges on their next assignment?",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:31.725Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
